import { DEFAULT_NUMBER_SETS, NumberSetsVennParams } from './number-sets-venn.model';

/**
 * Structured presets for the NumberSetsVennComponent.
 *
 * Each preset maps to the component's `params` input.
 * In a custom_component block, use a preset as a base and spread overrides:
 *
 * ```json
 * {
 *   "component_id": "number-sets-venn",
 *   "preset": "number-sets-default",
 *   "inputs": { "params": { "highlightedSet": "Q" } }
 * }
 * ```
 */

const BASE_PARAMS: NumberSetsVennParams = {
  sets: DEFAULT_NUMBER_SETS,
  highlightedSet: null,
  hoverEnabled: true,
  showExamples: true,
};

export const NUMBER_SETS_DEFAULT = {
  params: { ...BASE_PARAMS },
};

export const HIGHLIGHT_NATURALS = {
  params: { ...BASE_PARAMS, highlightedSet: 'N' as const, hoverEnabled: false },
};

export const HIGHLIGHT_INTEGERS = {
  params: { ...BASE_PARAMS, highlightedSet: 'Z' as const, hoverEnabled: false },
};

export const HIGHLIGHT_RATIONALS = {
  params: { ...BASE_PARAMS, highlightedSet: 'Q' as const, hoverEnabled: false },
};

export const HIGHLIGHT_REALS = {
  params: { ...BASE_PARAMS, highlightedSet: 'R' as const, hoverEnabled: false },
};

/**
 * Registry of all presets, keyed by the names used in content JSON `preset` field.
 */
export const NUMBER_SETS_VENN_PRESETS: Record<string, Record<string, unknown>> = {
  'number-sets-default': NUMBER_SETS_DEFAULT,
  'highlight-naturals': HIGHLIGHT_NATURALS,
  'highlight-integers': HIGHLIGHT_INTEGERS,
  'highlight-rationals': HIGHLIGHT_RATIONALS,
  'highlight-reals': HIGHLIGHT_REALS,
};
